/**
 * BarRow — a labeled CSS percentage bar (no chart library by design; the repo
 * has none and these reports only need proportional bars).
 */
interface BarRowProps {
  label: string;
  count: number;
  /** Bar width = count / max. */
  max: number;
  /** Optional right-side secondary text (e.g. "34%"). */
  hint?: string | null;
  color?: string;
  onClick?: () => void;
  active?: boolean;
}

export default function BarRow({ label, count, max, hint, color = 'bg-primary-500', onClick, active }: BarRowProps) {
  const pct = max > 0 ? Math.max(2, Math.round((count / max) * 100)) : 0;
  const inner = (
    <>
      <div className="flex items-center justify-between gap-2 text-sm">
        <span className="min-w-0 truncate font-medium text-gray-700 dark:text-gray-200">{label}</span>
        <span className="flex-shrink-0 tabular-nums text-gray-500 dark:text-gray-400">
          {count.toLocaleString()}{hint && <span className="ml-1.5 text-xs text-gray-400">{hint}</span>}
        </span>
      </div>
      <div className="mt-1 h-2 overflow-hidden rounded-full bg-gray-100 dark:bg-gray-700">
        <div className={`h-full rounded-full ${color} transition-all`} style={{ width: `${pct}%` }} />
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`block w-full rounded-lg px-2 py-2.5 text-left transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-700/40 sm:py-1.5 ${
          active ? 'bg-primary-50 ring-1 ring-primary-200 dark:bg-primary-900/20 dark:ring-primary-800' : ''
        }`}
      >
        {inner}
      </button>
    );
  }
  return <div className="px-2 py-1.5">{inner}</div>;
}
